// @flow
import React, { Fragment, useState, useEffect } from "react";
import AddSampleChargesToInvoice from "./AddSampleChargesToInvoice";
import Button from "../Button";

export default function SampleChargeToolbar({
  selectedSamples,
  reloadData,
  toolbarOptions = {},
}) {
  const [showActiveInvoices, setShowActiveInvoices] = useState(false);

  if (!showActiveInvoices) {
    return (
      <p style={{ padding: 10 }}>
        <Button
          title="Select Invoice to Add"
          disabled={selectedSamples.length === 0}
          onClick={() => setShowActiveInvoices(!showActiveInvoices)}
        />
      </p>
    );
  }

  return (
    <Fragment>
      <AddSampleChargesToInvoice
        selectedSamples={selectedSamples}
        reloadData={reloadData}
        laboratoryCompanyId={toolbarOptions.laboratoryCompanyId}
      />
    </Fragment>
  );
}
